module.exports = __webpack_public_path__ + "static/media/flanders@2x.5dee2f09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gear/display/flanders@2x.png
// module id = 324
// module chunks = 0